import { render, staticRenderFns } from "./accountJournalInitDetail.vue?vue&type=template&id=d99e830a&scoped=true"
import script from "./accountJournalInitDetail.vue?vue&type=script&lang=js"
export * from "./accountJournalInitDetail.vue?vue&type=script&lang=js"
import style0 from "./accountJournalInitDetail.vue?vue&type=style&index=0&id=d99e830a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99e830a",
  null
  
)

export default component.exports